export const AGENT_STORE_NAME = 'agent';
export const AUTH_STORE_NAME = 'auth';
export const ORDER_STORE_NAME = 'order';
export const CUSTOMER_STORE_NAME = 'customer';
export const PROMOCODE_STORE_NAME = 'promo_codes'
export const SETTINGS_STORE_NAME = 'settings'
export const ORDER_LOGS_STORE_NAME = 'orders-logs'
export const EARNINGS_STORE_NAME = 'earnings'